function Pangenome() {
  return (
    <>
    <main class="flex-shrink-0">
      <div class="container">
        <h2 class="mt-5">Pangenome</h2>
        <p class="lead">
          Link to pangenome browser, download section for data, and tooling.
        </p>
      </div>
    </main>
    </>
  );
}

export default Pangenome;